module.exports = __webpack_public_path__ + "img/CS-ProfiNew-Profiles.853d11ff.jpg";